// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "fale-coreano.firebaseapp.com",
  "projectId": "fale-coreano",
  "storageBucket": "fale-coreano.appspot.com",
  "messagingSenderId": "357960648277",
  "appId": "1:357960648277:web:81b1c5d8459ee2977b76dc",
  "measurementId": "G-4Z2X1K98PR",
  "apiKey": "AIzaSyB2VHSHHy7KY4Z1O9Xy0MYeX9dxBSr2dlA"
};
